import { Route, Switch } from 'react-router-dom';

import { LoginCard, OnboardingLayout } from '../ui';

import EditTariffContainer from './Edit/EditTariffContainer';
import SmartTariffSwitchWarning from './Edit/SmartTariffSwitchWarning';
import SubscribeContainer from './Edit/SubscribeContainer';
import { SuccessContainer } from './Onboarding';

const EditContainer = () => (
  <OnboardingLayout backgroundTint="blue">
    <LoginCard>
      <Switch>
        <Route path="/edit/tariff" component={EditTariffContainer} exact />
        <Route path="/edit/smart-tariff-switch-warning" component={SmartTariffSwitchWarning} exact />
        <Route path="/edit/subscribe" component={SubscribeContainer} exact />
        <Route path="/edit/check-subscription" component={SuccessContainer} exact />
      </Switch>
    </LoginCard>
  </OnboardingLayout>
);

export default EditContainer;
